import UserStore from '@/store/user';
import ControlStore from '@/store/core/Control';
import TaxModesStore from '@/store/tax-modes/taxModesList';
import ReceiptImage from '@/store/modals/receiptImage';
import BusinessTaxpayersStore from '@/store/business/taxpayers';
import BusinessPartnersStore from '@/store/business/partners';
import BusinessTaxpayerDetailsStore from '@/store/business/taxpayerDetails';
import BusinessTaxpayerProfileStore from '@/store/business/taxpayerProfile';
import SelfEmployeeTaxpayersListStore from '@/store/self-employee/taxpayersList';
import SelfEmployeePartnersListStore from '@/store/self-employee/partnersList';
import SelfEmployeeTaxpayerProfileStore from '@/store/self-employee/taxpayerProfile';
import SelfEmployeeTaxpayerDetailsStore from '@/store/self-employee/taxpayerDetails';
import SelfEmployeeTaxpayerIncomeYearStore from '@/store/self-employee/taxpayerIncomeYear';
import SelfEmployeeTaxpayerIncomeMonthStore from '@/store/self-employee/taxpayerIncomeMonth';
import SelfEmployeeTaxpayerPartnersStore from '@/store/self-employee/taxpayerPartners';
import SelfEmployeeTaxpayerReceiptsStore from '@/store/self-employee/taxpayerReceipts';
import SelfEmployeePartnersIncomeMonthStore from '@/store/self-employee/partnersIncomeMonth';
import SelfEmployeePartnersIncomeYearStore from '@/store/self-employee/partnersIncomeYear';
import SelfEmployeeTaxpayersControlStore from '@/store/self-employee/taxpayersControl';
import SelfEmployeePartnersControlStore from '@/store/self-employee/partnersControl';
import TaxpayerReceiptDtailsStore from '@/store/self-employee/taxpayerReceiptDetails';
import TaxpayerTaxDetailsStore from '@/store/self-employee/taxpayerTaxDetails';
import PlatformsTaxpayersListStore from '@/store/platforms/taxpayersList';
import PlatformsTaxpayerProfileStore from '@/store/platforms/taxpayerProfile';
import PlatformsTaxpayerDetailsStore from '@/store/platforms/taxpayerDetails';
import PlatformsTaxpayerStatisticsStore from '@/store/platforms/taxpayerStatistics';
import PlatformsSummaryStatisticsStore from '@/store/platforms/summaryStatistics';
import PlatformsTaxpayerIncomeStore from '@/store/platforms/taxpayerIncome';
import PlatformPartnersListStore from '@/store/platforms/partnersList';
import SelfEmployeeTaxpayerSummaryStatisticsStore from '@/store/self-employee/taxpayerSummaryStatistics';
import PlatformTaxpayerTaxStore from '@/store/platforms/taxpayerTax';
import ExternaTaxPayerslStore from '@/store/external/taxPayersStore';
import ExternalIncomeStore from '@/store/external/incomeStore';
import ExternalPaymentInfoStore from '@/store/external/paymentInfoStore';
import AdminTaxpayersListStore from '@/store/admin/taxpayersList';
import InternalStore from '@/store/internal/testStore';
import PlatformsTaxpayerReceiptImage from '@/store/platforms/taxpayerReceiptImage';

export class RootStores {
  userStore = new UserStore(this);
  controlStore = new ControlStore();

  taxModesStore = new TaxModesStore(this);

  receiptImage = new ReceiptImage(this);

  businessTaxpayersStore = new BusinessTaxpayersStore(this);
  businessPartnerStore = new BusinessPartnersStore(this);
  businessTaxpayerDetailsStore = new BusinessTaxpayerDetailsStore(this);
  businessTaxpayerProfileStore = new BusinessTaxpayerProfileStore(this);

  selfEmployeeTaxpayersControl = new SelfEmployeeTaxpayersControlStore();
  selfEmployeePartnersControl = new SelfEmployeePartnersControlStore();

  selfEmployeeTaxpayersListStore = new SelfEmployeeTaxpayersListStore(this);
  selfEmployeeTaxpayerProfileStore = new SelfEmployeeTaxpayerProfileStore(this);
  selfEmployeeTaxpayerDetailsStore = new SelfEmployeeTaxpayerDetailsStore(this);
  selfEmployeeTaxpayerIncomeYearStore = new SelfEmployeeTaxpayerIncomeYearStore(
    this,
  );
  selfEmployeeTaxpayerIncomeMonthStore =
    new SelfEmployeeTaxpayerIncomeMonthStore(this);
  selfEmployeeTaxpayerPartnersStore = new SelfEmployeeTaxpayerPartnersStore(
    this,
  );
  selfEmployeeTaxpayerReceiptsStore = new SelfEmployeeTaxpayerReceiptsStore(
    this,
  );
  selfEmployeeTaxpayerReceiptDetailsStore = new TaxpayerReceiptDtailsStore(
    this,
  );
  selfEmployeeTaxpayerTaxDetailsStore = new TaxpayerTaxDetailsStore(this);

  selfEmployeePartnerListStore = new SelfEmployeePartnersListStore(this);
  selfEmployeePartnerIncomeMonthStore =
    new SelfEmployeePartnersIncomeMonthStore(this);
  selfEmployeePartnerIncomeYearStore = new SelfEmployeePartnersIncomeYearStore(
    this,
  );
  selfEmployeeTaxpayerSummaryStatisticsStore =
    new SelfEmployeeTaxpayerSummaryStatisticsStore(this);

  platformsTaxpayersListStore = new PlatformsTaxpayersListStore(this);
  platformsTaxpayerProfileStore = new PlatformsTaxpayerProfileStore(this);
  platformsTaxpayerDetailsStore = new PlatformsTaxpayerDetailsStore(this);
  platformsTaxpayerStatisticsStore = new PlatformsTaxpayerStatisticsStore(this);
  platformsTaxpayerIncomeStore = new PlatformsTaxpayerIncomeStore(this);
  platformsTaxpayerTaxStore = new PlatformTaxpayerTaxStore(this);
  platformsSummaryStatisticsStore = new PlatformsSummaryStatisticsStore(this);
  platformsTaxpayerReceiptImageStore = new PlatformsTaxpayerReceiptImage(this);
  platformPartnersListStore = new PlatformPartnersListStore(this);

  externalTaxPayerslStore = new ExternaTaxPayerslStore(this);
  externalIncomeStore = new ExternalIncomeStore(this);
  externalPaymentInfoStore = new ExternalPaymentInfoStore(this);

  adminTaxpayersListStore = new AdminTaxpayersListStore(this);

  internalStore = new InternalStore(this);
}

export default new RootStores();
